module.exports = __webpack_public_path__ + "img/icon-6.5ec3fa41.png";